import toast from "react-hot-toast";
import { log, supabase } from ".";

export const getClientes = async ({ pais, orderBy = "nombre", ascending = true }) => {
  try {
    const data = await supabase.select("clientes", {
      filters: { pais },
      orderBy,
      ascending,
    });

    if (data?.length === 0) {
      toast.error("No hay clientes cargados en la base de datos");
      throw new Error("No data found");
    }

    return data;
  } catch (error) {
    log.error("getClientes", error);
    throw error;
  }
};
